import Spline from "@splinetool/react-spline";
import { StyleSheet, View } from "react-native";
import AssessmentOrbController from "../realtimeAssessment/AssessmentOrbController";
import TurnBasedOrbController from "../turnbasedAssessment/TurnBasedOrbController";
import { useRef } from "react";
import { Application } from "@splinetool/runtime";
import Loader from "../../../components/common/status/Loader/Loader";

interface AssessmentSpeakingOrbProps {
  dynamicHeight: number;
  orbLoading: boolean;
  setOrbLoading: (loading: boolean) => void;
  useLiveKit?: boolean;
  isPlaying?: boolean;
  audioLevel?: number; // 0..1, optional
}

const AssessmentSpeakingOrb = ({
  dynamicHeight,
  orbLoading,
  setOrbLoading,
  useLiveKit = true,
  isPlaying = false,
  audioLevel = 0,
}: AssessmentSpeakingOrbProps) => {
  const orb = useRef(null);

  const onLoad = (spline: Application) => {
    setOrbLoading(false);
    const obj = spline.findObjectById("02f9e61e-081c-484d-8258-c53281906a3f");
    orb.current = obj;
  };

  return (
    <View
      style={[styles.orbContainer, { height: dynamicHeight }]}
      accessible={false}
      accessibilityElementsHidden={true}
      importantForAccessibility="no"
      aria-hidden={true}>
      {orbLoading && <Loader />}
      <Spline scene="https://prod.spline.design/eGVArbV9JzcVNsir/scene.splinecode" onLoad={onLoad} />
      {useLiveKit ? (
        <AssessmentOrbController orb={orb} />
      ) : (
        <TurnBasedOrbController orb={orb} isPlaying={isPlaying} level={audioLevel} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  orbContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "100%",
    minWidth: 200,
  },
});

export default AssessmentSpeakingOrb;
